import React from "react";
import "./Footer.css";
import logo from "../../Assets/Banner/swasthmitra_logo.png";
import paymentIcon from "../../Assets/paymentIcon.png";
import { FaFacebookF, FaInstagram, FaYoutube, FaPinterest } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { Link } from "react-router-dom";

const Footer = () => {
  const handleSubscribe = (e) => {
    e.preventDefault();
    alert("Subscribed Successfully");
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const getCurrentYear = () => new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__container">
        {/* Left */}
        <div className="footer_left">
          <div className="footer_logo_container">
            <img src={logo} alt="logo" />
          </div>

          <p>Powered by Raju Medical Stores</p>
          <p>Welcome to Swasthmitra</p>

          <div className="footer_address">
            <strong>info@swasthmitra.com</strong>

            <a
              href="tel:+917007512120"
              style={{
                color: "black",
                textDecoration: "none",
                fontWeight: "500",
                marginTop: "6px",
              }}
            >
              📞 Call Now
            </a>
          </div>

          {/* Added License / GST */}
          <div className="footer_license">
            <p>
              <strong>D.L NO:</strong> DLA/07/20B/2010, DLA/07/21B/2010
            </p>
            <p>
              <strong>GSTIN:</strong> 09AKAPV8901B1Z7
            </p>
          </div>

          <div className="social_links">
            <FaFacebookF />
            <FaXTwitter />
            <FaInstagram />
            <FaYoutube />
            <FaPinterest />
          </div>
        </div>

        {/* Company */}
        <div className="footer_content">
          <h5>Company</h5>
          <div className="links_container">
            <ul onClick={scrollToTop}>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/careers">Career</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>
        </div>

        {/* Services */}
        <div className="footer_content">
          <h5>Medical Services</h5>
          <div className="links_container">
            <ul onClick={scrollToTop}>
              <li><Link to="/services/new-arrivals">New Services</Link></li>
              <li><Link to="/services/accessories">Medical Accessories</Link></li>
              <li><Link to="/services/men">Men's Health</Link></li>
              <li><Link to="/services/women">Women's Health</Link></li>
            </ul>
          </div>
        </div>

        {/* Help */}
        <div className="footer_content">
          <h5>Help</h5>
          <div className="links_container">
            <ul onClick={scrollToTop}>
              <li><Link to="/customer-service">Customer Service</Link></li>
              <li><Link to="/legal-privacy">Legal & Privacy</Link></li>
            </ul>
          </div>
        </div>

        {/* Subscribe */}
        <div className="footer_right">
          <h5>Subscribe</h5>
          <p>
            Be the first to get latest news, offers and promotions.
          </p>

          <form onSubmit={handleSubscribe}>
            <input type="email" placeholder="Your email address" required />
            <button type="submit">Join</button>
          </form>

          <h6>Secure Payments</h6>

          <div className="paymentIconContainer">
            <img src={paymentIcon} alt="payments" />
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="footer_bottom">
        <div>
          <p>
            © {getCurrentYear()} Swasthmitra. All Rights Reserved | Made By{" "}
            <a
              href="https://www.linkedin.com/in/anuj-kumar-a7954a257/"
              target="_blank"
              rel="noreferrer"
              style={{ color: "#C22928", textDecoration: "none" }}
            >
              Anuj Kumar
            </a>{" "}
            ❤️
          </p>

          {/* Added Disclaimer */}
          <p className="footer_disclaimer">
            Disclaimer: All medicines, products, billing and business
            transactions are fulfilled by <strong>Raju Medical Stores</strong>.
            Swasthmitra is only a digital platform to facilitate services.
          </p>
        </div>

        <div className="footerLangCurrency">
          <div className="footerLang">
            <p>Language</p>
            <select>
              <option>United States | English</option>
              <option>Hindi</option>
            </select>
          </div>

          <div className="footerCurrency">
            <p>Currency</p>
            <select>
              <option>₹ INR</option>
            </select>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;